import React, {useEffect, useState} from "react";
// import UICardImage from "../../../card/UICardImage";
import {useTranslation} from "react-i18next";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faMicrophoneAlt} from "@fortawesome/free-solid-svg-icons";
import playImg from "../images/playImg.png";
import styles from "./UIMeetingRecord.module.scss";
// import ModalPlayRecord from "../../../modals/ModalPlayRecord";
import UIModalPlayRecord from "../UIModalPlayRecord";
import {getUrl} from "src/service/files.service";

function UIMeetingRecord(props: any) {
  // const { navigator } = props;
  const { t } = useTranslation();
  const fileServiceDownloadURL: any =
    window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + "/downloadFile?fileId=";
  const isAnother: any = props.isAnother;
  const [videoAudioAlready, setVideoAudioAlready]: any = useState(true);
  const [isOpenAudioPopup, setOpenAudioPopup] = useState(false);
  let server: any = props.messageDetails?.server;

  const handleAudioPopup = () => {
    setOpenAudioPopup(false);
  };

  useEffect(() => {
    checkGetUrlFile();
  }, []);
  const [urlFile, setUrlFile] = useState("");
  const checkGetUrlFile = async () => {
    let url: any =
      fileServiceDownloadURL + props.messageDetails?.path + "&size=100";
    url = await getUrl(url, props.messageDetails?.path, 100, "post");
    setUrlFile(url);
  };

  return (
    <>
      <div
        className={
          isAnother > 1
            ? styles.msgStyleMeetingRecord2
            : styles.msgStyleMeetingRecord1
        }
        onClick={() => {
          if (props.isSelect) return;
          if (!server && videoAudioAlready) {
            props.handlePreviewImage(
              "video",
              props.messageDetails?.title,
              props.messageDetails?.path,
              ""
            );
          } else {
            console.log("Pop up", isOpenAudioPopup);
            setOpenAudioPopup(true);
          }
        }}
      >
        <div className={isAnother > 1 ? styles.openGraph2 : styles.openGraph1}>
          <div
            className={styles.detailHtml}
            style={{
              display: "flex",
              verticalAlign: "middle",
              alignItems: "center",
            }}
          >
            <div className={styles.chatMeetingThumnail}>
              {props.messageDetails?.path && !server ? (
                <div>
                  <img
                    width="80px"
                    height="80px"
                    onError={() => setVideoAudioAlready(false)}
                    style={{
                      borderRadius: "15px",
                      objectFit: "cover",
                      objectPosition: "center",
                    }}
                    src={urlFile}
                  />
                </div>
              ) : (
                <div>
                  <FontAwesomeIcon
                    className="font-awesome"
                    icon={faMicrophoneAlt}
                    style={{
                      color: isAnother === 0 ? "#000" : "#FFF",
                      width: "10.8px",
                      height: "10.8px",
                    }}
                  />
                  <i
                    className="fa-microphone-alt"
                    style={{
                      fontSize: "xx-large",
                      color: isAnother === 0 ? "#000" : "#FFF",
                    }}
                  ></i>
                </div>
              )}

              {!server && (
                <div className={styles.playImg}>
                  <div
                    style={{
                      width: "70px",
                      height: "70px",
                      backgroundPosition: "center",
                      backgroundImage: `url(${playImg})`,
                      backgroundSize: "cover",
                      margin: "auto",
                    }}
                  ></div>
                </div>
              )}
            </div>
            <div
              className={
                isAnother > 1 ? styles.descLinkVideo2 : styles.descLinkVideo1
              }
              style={{
                width: server ? "calc(100% - 30px)" : "calc(100% - 80px)",
              }}
            >
              {props.messageDetails?.title && !server ? (
                <p className={styles.linkTitle}>
                  {props.messageDetails?.title}
                </p>
              ) : !props.messageDetails?.title && !server ? (
                <p className={styles.linkTitle}>{t("Meeting")}</p>
              ) : (
                <p className={styles.linkTitle}> {t("Recorded conference")}</p>
              )}
              {!server && (
                <p className={styles.linkDescription}>
                  {t("Recorded conference")}
                </p>
              )}
              <p className={styles.linkDescription}>
                {t("By") + " : " + props.username}
              </p>
            </div>
          </div>
        </div>
      </div>
      {server && (
        <UIModalPlayRecord
          fileId={props.messageDetails?.path}
          isOpen={isOpenAudioPopup}
          onClose={handleAudioPopup}
        />
      )}
    </>
  );
}

export default React.memo(UIMeetingRecord);
